export const FETCH_ADDRESS_LIST = 'FETCH_ADDRESS_LIST';
export const FETCH_ADDRESS_LIST_SUCCESS = 'FETCH_ADDRESS_LIST_SUCCESS';
export const FETCH_ADDRESS_LIST_ERROR = 'FETCH_ADDRESS_LIST_ERROR';

export const SET_EDITING = 'SET_EDITING_PAYMENT_METHOD';
export const CLEAR_EDITING = 'CLEAR_EDITING_PAYMENT_METHOD';

export const SET_SELECTED_BILLING_ADDRESS_ID =
  'SET_SELECTED_BILLING_ADDRESS_ID';
